module.exports = __webpack_public_path__ + "img/telephone.877c5214.svg";